import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, computed } from 'vue'
import Dialog from './Dialog.vue'
import BaseForm from './BaseForm2.vue';
import { ElMessage } from 'element-plus';

import { getFindSystem, setFindSystem } from '../loginApi'

import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformPer',
  props: {
  userId: { type: String },
  open: { type: Boolean, default: false }
},
  emits: ['update:open','getList'],
  setup(__props, { emit: emits }) {

const props = __props;

const store = useStore();
const system = computed(() => store.getters.getSystem);

const { t } = useI18n();



const open = computed({
  get: () => props.open,
  set: (val: boolean) => {
    emits('update:open', val)
  },
})
const formState = ref<any>({})
const loading = ref(true)
watch(() => props.open, (newVal) => {
  if (newVal) {
    loading.value = true
    getFindSystem(props.userId).then(res => {
      formState.value.systemIds = res.data.map((e) => e.id)
    }).finally(()=>loading.value = false)
  }
})

const variable = [
  {
    key: 'systemIds',
    name: t('login.relatedPlatforms'),
    type: 'select',
    multiple: true,
    options: system.value
  }
]

const ok = async () => {
  const res = await setFindSystem({ userId: props.userId, systemIds: formState.value.systemIds })
  ElMessage({
    message: res.resultMessage,
    type: 'success',
  })
  emits('update:open', false)
  emits('getList')
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Dialog, {
    open: open.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
    ok: ok
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(BaseForm, {
        variable: variable,
        "form-val": formState.value
      }, null, 8, ["form-val"]), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})